import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './App.css';
import GameShell from './core/GameShell';
import LandingPage from './components/LandingPage';

// Register all games
import './games/tensai';
import './games/spelling-blitz';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/games/:slug" element={<GameShell />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
